import { routes } from '../config/api_routes'

export const deliveryZoneService = {
    
    getPostalCode: (formData) => window.axios.post(routes.getPostalCodeApi,formData),

    addPostalCode: (formData) => window.axios.post(routes.addPostalCodeApi,formData),

    getPostalCodeInfo: (formData) => window.axios.post(routes.getPostalCodeInfoApi,formData),

    deletePostalCode: (formData) => window.axios.post(routes.deletePostalCodeApi, formData),

    editPostalCode: (formData) => window.axios.post(routes.editPostalCodeApi,formData),

    getDeliveryZone: (formData) => window.axios.post(routes.getDeliveryZoneApi,formData),

    getVendorCountry: () => window.axios.get(routes.getVendorCountryApi),

    getVendorState: (formData) => window.axios.post(routes.getVendorStateApi,formData),

    getVendorCity: (formData) => window.axios.post(routes.getVendorCityApi,formData),

    getAllState: () => window.axios.get(routes.getAllStateApi),

    getAllCity: () => window.axios.get(routes.getAllCityApi),

    addDeliveryZone: (formData) => window.axios.post(routes.addDeliveryZoneApi,formData),

    getDeliveryInfo: (formData) => window.axios.post(routes.getDeliveryInfoApi,formData),

    editDeliveryZone: (formData) => window.axios.post(routes.editDeliveryZoneApi,formData),

    zoneExportCsv: (formData) => window.axios.post(routes.zoneExportCsvApi, formData),

    deleteZone: (formData) => window.axios.post(routes.deleteZoneApi, formData),

    checkPostalCode: (formData) => window.axios.post(routes.checkPostalCodeApi, formData),

    checkBillPostalCode: (formData) => window.axios.post(routes.checkBillPostalCodeApi, formData),
}